import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import SmartLedgersEditor from "./SmartLedgersEditor";

const SmartLedgersEditorPage = () => {
  const { smartLedgerId } = useParams();
  const navigate = useNavigate();
  const [smartLedger, setSmartLedger] = useState(null);
  const [loading, setLoading] = useState(true);

  const isNew = smartLedgerId === "new";

  const createEmptySmartLedger = () => ({
    _id: crypto.randomUUID(),
    name: "New Smart Ledger",
    type: "",
    owner: "",
    accounts: [{ id: "" }],

  });

  useEffect(() => {
    const fetchSmartLedger = async () => {
      if (isNew) {
        setSmartLedger(createEmptySmartLedger());
        setLoading(false);
      } else {
        try {
          const res = await fetch(`https://ledgers.poc.mrc.ai/api/smartledgers/${smartLedgerId}`);
          const data = await res.json();
          setSmartLedger(data);
        } catch (error) {
          console.error("Error fetching Smart Ledger:", error);
        } finally {
          setLoading(false);
        }
      }
    };

    fetchSmartLedger();
  }, [smartLedgerId, isNew]);

  const handleSave = async (updatedSmartLedger) => {
  try {
    const method = isNew ? "POST" : "PUT";
    const url = isNew
      ? `https://ledgers.poc.mrc.ai/api/smartledgers`
      : `https://ledgers.poc.mrc.ai/api/smartledgers/${smartLedgerId}`;

    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(updatedSmartLedger),
    });

    if (!res.ok) throw new Error("Failed to save Smart Ledger");

    const saved = await res.json();
    setSmartLedger(saved);
  } catch (err) {
    console.error("Error saving Smart Ledger:", err);
  }
};

  const handleClose = () => navigate("/");

  if (loading) return <Spinner />;

  return <SmartLedgersEditor smartLedger={smartLedger} onClose={handleClose} isNew={isNew} />;
};

export default SmartLedgersEditorPage;
